import React from 'react';
import Header from '../components/admin/Header';
import SideBar from '../components/admin/SideBar';
import Breadcrumbs from '../components/admin/Breadcrumbs';
import WorkspaceLayout from './WorkspaceLayout';

export default function AdminLayout({ children }) {
  return <WorkspaceLayout Header={Header} SideBar={SideBar} Breadcrumbs={Breadcrumbs}>{children}</WorkspaceLayout>;
}
